import {useEffect} from "react";
import useYearType from "../Stores/YearStore";

interface YearsProps {
  displayValue: number;
  id?: string;
}

const YearsMenu: React.FC<YearsProps> = ({displayValue, id}) => {
  const yearValue = useYearType((state) => state.yearValue);
  const setYearValue = useYearType((state) => state.setYearValue);
  const yearList = useYearType((state) => state.yearList);

  useEffect(() => {}, [displayValue]);

  return (
    <select
      id={id}
      className="text-center lg:text-center pl-1 pr-4 xl:select xl:select-bordered text-[12px] bg-[#E5DCDD] appearance-none focus:outline-none focus:ring-0 focus:border-transparent"
      defaultValue={yearValue}
      onChange={(event) => setYearValue(Number(event.target.value))}>
      {yearList.map((label, index) => (
        <option key={index} value={index}>
          {label}
        </option>
      ))}
    </select>
  );
};

export default YearsMenu;
